import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { kenoGameService } from '../kenoService/gameService';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

export class KenoGameConnection {
  executeGameConnections() {
    mainGameConnection.onDoSpinResult(kenoGameService.handleDoSpinResult.bind(kenoGameService));
    mainGameConnection.onGetInitialStateResult(
      kenoGameService.onGetInitialStateResult.bind(kenoGameService)
    );
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const kenoGameConnection = new KenoGameConnection({ url: `${socketUrl}game` });
